<template>
  <div class="q-pb-sm layout-padding">
      <div class="row">
        <h5 class="q-pa-md col-12">
          <q-icon color="primary" name="fa fa-user"></q-icon>User Details
        </h5>
        <q-field
          class="q-pa-md col-4"
          error-label="First name is required"
          :error="validation.userForm.USER_FIRST_NAME.$error"
        >
          <q-input
            float-label="First Name"
            :value="userForm.USER_FIRST_NAME"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_FIRST_NAME.$invalid },
              {icon: 'fa fa-check', condition: !validation.userForm.USER_FIRST_NAME.$invalid && validation.userForm.USER_FIRST_NAME.$dirty}
            ]"
            @blur="validation.userForm.USER_FIRST_NAME.$touch"
            @keyup="updateUserForm({ field: 'USER_FIRST_NAME', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>

        <q-field class="q-pa-md col-4">
          <q-input
            float-label="Middle Name"
            :value="userForm.USER_MIDDLE_NAME"
            @keyup.stop="updateUserForm({ field: 'USER_MIDDLE_NAME', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>

        <q-field
          class="q-pa-md col-4"
          :error="validation.userForm.USER_LAST_NAME.$error"
          error-label="Last name is required"
        >
          <q-input
            float-label="Last Name"
            :value="userForm.USER_LAST_NAME"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_LAST_NAME.$invalid },
              {icon: 'fa fa-check', condition: !validation.userForm.USER_LAST_NAME.$invalid && validation.userForm.USER_LAST_NAME.$dirty}
            ]"
            @blur="validation.userForm.USER_LAST_NAME.$touch"
            @keyup.stop="updateUserForm({ field: 'USER_LAST_NAME', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-2">
          <q-select
            float-label="Suffix"
            :value="userForm.USER_SUFFIX"
            :options="suffixOptions"
            @change="val => updateUserForm({ field: 'USER_SUFFIX', value: val})"
            :disable="!canEdit"
          />
        </q-field>
        <!-- 2/6/2019 2:42pm Christi said to remove SSN -->
        <!-- <q-field
          class="q-pa-md col-2"
          style="padding-right:0; width:100px"
          :error="validation.userForm.USER_SSN_A.$error || validation.userForm.USER_SSN_B.$error"
        >
          <q-input
            stack-label="SSN"
            v-mask="'SSS-SS'"
            :value="userForm.USER_SSN_A"
            type="password"
            @keyup.stop="updateUserForm({ field: 'USER_SSN_A', value: $event.target.value })"
            @input="isSSNAComplete"
            @blur="validation.userForm.USER_SSN_A.$touch"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
        <q-field
          class="q-pa-md col-3"
          style="width:80px;padding-left:0"
          :error="validation.userForm.USER_SSN_B.$error || validation.userForm.USER_SSN_A.$error"
        >
          <q-input
            stack-label="Last 4"
            v-mask="'9999'"
            ref="USER_SSN_B"
            :value="userForm.USER_SSN_B"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_SSN_B.$invalid || validation.userForm.USER_SSN_A.$invalid },
              {icon: 'fa fa-check', condition: (!validation.userForm.USER_SSN_B.$invalid && validation.userForm.USER_SSN_B.$dirty) && (!validation.userForm.USER_SSN_A.$invalid && validation.userForm.USER_SSN_A.$dirty)}
            ]"
            @keyup.stop="updateUserForm({ field: 'USER_SSN_B', value: $event.target.value })"
            @blur="validation.userForm.USER_SSN_B.$touch"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field> 
        .{{userForm.USER_DOB}}.-->
        <q-field
          class="q-pa-md col-3"
          :error="validation.userForm.USER_DOB.$error"
          error-label="Invalid Date"
          helper="MM/DD/YYYY"
        >
          <sl-date-time
            :disable="!canEdit"
            :value="userForm.USER_DOB"
            float-label="Date of Birth"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_DOB.$invalid },
              {icon: 'fa fa-check', condition: !validation.userForm.USER_DOB.$invalid && validation.userForm.USER_DOB.$dirty }
            ]"
            @input="(newVal) => updateUserForm({ field: 'USER_DOB', value: newVal })"
            @blur="validation.userForm.USER_DOB.$touch"
            width="100%"
            required
          />
        </q-field>
        <q-field class="q-pa-md col-3">
          <q-select
            float-label="Gender"
            filter
            autofocus-filter
            :value="userForm.USER_GENDER"
            :options="genderOptions"
            @change="val => updateUserForm({ field: 'USER_GENDER', value: val })"
            :disable="!canEdit"
          />
        </q-field>
        <q-field
          class="q-pa-md col-4"
          :error="validation.userForm.USER_EMAIL.$error"
          error-label="Must be a valid email"
        >
          <q-input
            float-label="Email"
            :value="userForm.USER_EMAIL"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_EMAIL.$invalid },
              {icon: 'fa fa-check', condition: !validation.userForm.USER_EMAIL.$invalid && validation.userForm.USER_EMAIL.$dirty}
            ]"
            @blur="validation.userForm.USER_EMAIL.$touch"
            @keyup.stop="updateUserForm({ field: 'USER_EMAIL', value: $event.target.value })"
            :disable="!canEdit ||  !$p(['ADMIN','AFFILIATE','MANAGER', 'RECRUITER'],'or') && !userWizardModalOpen"
            required
          ></q-input>
        </q-field>
      </div>
      <div class="row">
        
        <q-field
          class="q-pa-md col-3"
          :error="validation.userForm.USER_PHONE.$error"
          error-label="Phone must be numeric"
        >
          <q-input
            float-label="Phone"
            type="tel"
            v-mask="'(999) 999-9999'"
            :value="userForm.USER_PHONE"
            :after="[
              {icon: 'flag', condition: validation.userForm.USER_PHONE.$invalid },
              {icon: 'fa fa-check', condition: !validation.userForm.USER_PHONE.$invalid && validation.userForm.USER_PHONE.$dirty}
            ]"
            @blur="validation.userForm.USER_PHONE.$touch"
            @keyup.stop="updateUserForm({ field: 'USER_PHONE', value: $event.target.value})"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
        <q-field class="q-pa-md col-2">
          <q-input
            float-label="Ext"
            :value="userForm.USER_PHONE_EXT"
            @keyup.stop="updateUserForm({ field: 'USER_PHONE_EXT', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
        <q-field class="q-pa-md col-3">
          <q-input
            float-label="Fax"
            :value="userForm.USER_FAX"
            v-mask="'999-999-9999'"
            @keyup.stop="updateUserForm({ field: 'USER_FAX', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
        <q-field class="q-pa-md col-3" :helper="'Please be careful!'">
          <q-input
            float-label="Customer ID (Auth.net)"
            :value="userForm.CUSTOMER_ID"
            v-mask="'9999999999999999999'"
            v-if="$p(['ADMIN'])"
            @keyup.stop="updateUserForm({ field: 'CUSTOMER_ID', value: $event.target.value })"
            :disable="!canEdit"
            required
          ></q-input>
        </q-field>
      </div>
      <div class="user-roles row" v-if="anyActiveRole && !userWizardModalOpen">
        <div class="col-12 q-pa-md">
          <h5>
            <q-icon name="fa fa-bolt" color="primary"/>
            Current Roles
            <q-btn
              outline size="sm"
              @click.native="updateSelectedTab('roles')"
              v-if="$p(['ADMIN','MANAGER','RECRUITER','AFFILIATE'],'or') ">
                Manage Roles
            </q-btn>
          </h5>
        </div>
        <div class="col-12 q-pa-md">
          <q-list class="round"
            separator>
            <q-item v-if="administratorForm.ACTIVE_IND">
              <q-item-main><h6><q-icon color="primary" name="fa fa-magic"></q-icon> Administrator</h6></q-item-main>
            </q-item>
            <q-item v-if="managerForm.ACTIVE_IND">
              <q-item-main><h6><q-icon color="primary" name="fa fa-users"></q-icon> Manager</h6></q-item-main>
            </q-item>
            <q-item v-if="affiliateForm.ACTIVE_IND">
              <q-item-main><h6><q-icon color="primary" name="fa fa-building"></q-icon> Affiliate</h6></q-item-main>
            </q-item>
            <q-item v-if="recruiterForm.ACTIVE_IND">
              <q-item-main><h6><q-icon color="primary" name="fa fa-user-plus"></q-icon> Recruiter</h6></q-item-main>
            </q-item>
            <q-item v-if="instructorForm.ACTIVE_IND">
              <q-item-main><h6><q-icon color="primary" name="fa fa-graduation-cap"></q-icon> Instructor</h6></q-item-main>
              <div class="label bg-green" v-if="instructorForm.LK_INSTRUCTOR_STATUS_ID == 1">Approved</div>
              <div class="label bg-red" v-if="!instructorForm.LK_INSTRUCTOR_STATUS_ID">Awaiting Approval</div>
            </q-item>
          </q-list>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import SlDateTime from "components/Shared/DatePicker";
const moment = require("moment");
import AwesomeMask from "awesome-mask";

export default {
  name: "UserDetails",
  props: ["validation"],
  components: {
    SlDateTime
  },
  directives: {
    mask: AwesomeMask
  },
  mounted() {
    this.validation.$reset;
  },
  data() {
    return {
      genderOptions: this.$store.state.shared.genders,
      moment: moment
    };
  },
  computed: {
    ...mapState({
      suffixOptions: state => state.shared.suffixes,
      canEdit: state => state.users.userModal.canEdit
    }),
    ...mapState("users", {
      userForm: state => state.userForm,
      instructorForm: state => state.instructorForm,
      affiliateForm: state => state.affiliateForm,
      managerForm: state => state.managerForm,
      administratorForm: state => state.administratorForm,
      recruiterForm: state => state.recruiterForm,
      userWizardModalOpen: s => s.userWizardModal.open
    }),
    ...mapGetters(["suffixOptions"]),
    ...mapGetters("users", [
      "userTypeOptions",
      "statusOptions",
      "userTypeOptions",
      "userStatusOptions"
    ]),
    selectedSuffix() {
      return this.userForm.USER_SUFFIX ? this.suffixOptions[this.userForm.USER_SUFFIX - 1].label:'';
    },
    anyActiveRole(){
      let vm = this
      return vm.administratorForm.ACTIVE_IND
             || vm.managerForm.ACTIVE_IND
             || vm.affiliateForm.ACTIVE_IND
             || vm.instructorForm.ACTIVE_IND
             || vm.recruiterForm.ACTIVE_IND
    }
  },
  methods: {
    ...mapMutations("users", [
      "updateUserForm",
      "updateSuffixText",
      'updateSelectedTab'
    ]),
    validateDate(date, required) {
      let formats = ["M-D-YYYY", "M/D/YYYY", "M.D.YYYY"];
      let isValid = moment(date, formats, true).isValid();
      if (!isValid && !required && !date) {
        isValid = true;
      }
      return isValid ? true : false;
    },
    // Christi said to remove SSN on 2/6/2019 2:42pm
    // isSSNAComplete(val) {
    //   if (val && val.toString().replace(/[^0-9]/g,"").length === 5) {
    //     this.updateUserForm({ field: "USER_SSN_A", value: val });
    //     this.$refs.USER_SSN_B.focus();
    //   }
    // }
  }
};
</script>

<style scoped lang="stylus">
.user-roles
  .label
    display inline-block
    float left
    clear left
    border-radius:5px
  .q-list
    padding 0
  h5
    .q-btn
      float right
      padding 6px 13px
      line-height 18px
.q-tabs-panes {
  display: flex;
}

.sl-row.sl-abs {
  height: calc(100% - 110px);
}
</style>
